<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('dictionary.project')"
    icon="res-project"
    :res-name="detailData.project"
    :current-tab="params.windowData.currentTab"
    :loaded="loaded"
    :tabs="detailTabs"
    @tab-change="handleTabChange">
    <component
      :is="params.windowData.currentTab"
      :id="listId"
      :data="detailData"
      :getParams="getParams"
      :defaultDateMode="params.dateMode"
      :defaultCustomDate="params.customDate"
      @tab-change="handleTabChange" />
  </base-side-page>
</template>

<script>
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import PredictData from '../components/Data'

export default {
  name: 'PredictConfigSidePage',
  components: {
    PredictData,
  },
  mixins: [SidePageMixin, WindowsMixin],
  data () {
    return {
      detailTabs: [
        { label: this.$t('bill.predict_data'), key: 'predict-data' },
        { label: this.$t('bill.predict_adjustment_data'), key: 'predict-adjust', disabled: true },
      ],
    }
  },
  computed: {
    listId () {
      switch (this.params.windowData.currentTab) {
        case 'predict-data':
          return 'OverviewForCloudDomainSidePage'
        default:
          return ''
      }
    },
    getParams () {
      return {
        tenant_id: this.detailData.tenant_id,
        scope: this.$store.getters.scope,
      }
    },
  },
}
</script>
